import React from 'react';
import BlurText from './BlurText';
import styles from './InfoView.module.css';

const InfoView: React.FC = () => {
  const handleAnimationComplete = () => {
    // Animation completed
  };

  const before = 'ART DIRECTOR, SHOOTING AND EVENT PRODUCER';

  return (
    <section className={styles.wrapper}>
      <div className={styles.centerBox}>
        <BlurText
          text={before}
          delay={200}
          animateBy="words"
          direction="top"
          onAnimationComplete={handleAnimationComplete}
          className={styles.text}
          afterNode={
            <div className={styles.linksContainer}>
              <a
                href="/file/PORTFOLIO Novembre 2025.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                CV
              </a>
              <span className={styles.separator}>-</span>
              <a
                href="mailto:info@alessiamastrorilli.it"
                className={styles.link}
              >
                INFO@ALESSIAMASTRORILLI.IT
              </a>
            </div>
          }
        />
      </div>
    </section>
  );
};

export default InfoView;
